<h4>Tu mercado de fichajes</h4>
<div class="resume">
    <div class="counter">
        <h3 class="price">{{totalSold-totalBought}}<p> M€</p></h3>
        <p>Balance</p>
    </div>
    <div class="counter">
        <h3 class="price">{{totalSold}}<p> M€</p></h3>
        <p>Salidas</p>
    </div>
    <div class="counter">
        <h3 class="price">{{totalBought}}<p> M€</p></h3>
        <p>Fichajes</p>
    </div>
</div>
<div class="grid-container">
    <!--Plantilla actual-->
    <div class="grid-item">
        <mat-card appearance="outlined">
            <mat-card-content class="responsive_table">
                <table mat-table [dataSource]="currentTeam">
                    <!-- Player Column -->
                    <ng-container matColumnDef="players">
                        <th mat-header-cell *matHeaderCellDef> Plantilla actual </th>
                        <td mat-cell *matCellDef="let element">
                        {{ element.commonName }}
                        </td>
                    </ng-container>
        
                    <!-- Actions Column -->
                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="hover-text">Vender</span>
                        </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="['players', 'price']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['players', 'price']" class="clickable-row" (click)="sellPlayer(row)"></tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>

    <!--Ventas-->
    <div class="grid-item">
        <mat-card appearance="outlined">
            <mat-card-content class="responsive_table">
                <table mat-table [dataSource]="soldPlayers" matSort #sortVentas="matSort">
                    <!-- Player Column -->
                    <ng-container matColumnDef="players">
                        <th mat-header-cell *matHeaderCellDef> Ventas </th>
                        <td mat-cell *matCellDef="let element">
                        {{ element.player.commonName }}
                        </td>
                    </ng-container>
        
                    <!-- Actions Column -->
                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="price">{{ totalSold }} M€</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="default-text">{{ element.price }} M€</span>
                            <span class="hover-text">Recomprar</span>
                        </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="['players', 'price']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['players', 'price']" class="clickable-row" (click)="unsellPlayer(row.player,row.price)"></tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>

    <!--Fichajes-->
    <div class="grid-item">
        <mat-card appearance="outlined">
            <mat-card-content class="responsive_table">
                <table mat-table [dataSource]="signings" matSort #sortFichajes="matSort">
                    <!-- Player Column -->
                    <ng-container matColumnDef="players">
                        <th mat-header-cell *matHeaderCellDef> Fichajes </th>
                        <td mat-cell *matCellDef="let element">
                        {{ element.player.commonName ? element.player.commonName : element.player.name }}
                        </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef class="align-right" mat-sort-header="price">{{totalBought}} M€</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="default-text">
                                <mat-icon *ngIf="element.price == null">payments</mat-icon>
                                {{ element.price }} M€
                            </span>
                            <span class="hover-text">Gestionar fichaje</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="addAction">
                        <!-- Celda vacía para las filas normales -->
                        <td mat-cell *matCellDef="let element"></td>

                        <!-- Celda del footer con el botón -->
                        <td mat-footer-cell *matFooterCellDef colspan="2" class="add-cell">
                        <button mat-icon-button color="primary" (click)="buyPrice()">
                            <mat-icon>add</mat-icon>
                        </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['players', 'price']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['players', 'price']" class="clickable-row" (click)="buyPrice(row.player, row.positionId)"></tr>                
                    
                    <tr mat-footer-row  *matFooterRowDef="['addAction']" matTooltip="Fichar jugador"></tr>
                </table>
            </mat-card-content>
        </mat-card>
    </div>
</div>